<template>
    <main class="main">
        <div class="container">
            <section-header
                title="Pomoc"
                sub-title="
                    Sekcja umożliwia Ci kontakt z nami bezpośrednio przez formularz oraz
                    daje dostęp do instrukcji i najczęściej zadawanych pytań
                "
            />
            <div class="mt-4 row">
                <div class="col-md-8 mb-4 mb-md-0">
                    <tutorials-to-download
                        tile-class="col-md-12 col-lg-6"
                        v-if="isLotteryUser || isShopUser"
                    />
                    <contact-form v-else />
                </div>
                <div class="col-md-4">
                    <contact-info-wrapper :data="this.$brand.settings.help"/>
                </div>
            </div>
            <div v-if="!isLotteryUser && !isShopUser" class="row mt-4">
                <div class="col-12">
                    <tutorials-to-download />
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <faq-section />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import {
    FaqSection,
    ContactForm,
    ContactInfoWrapper,
    TutorialsToDownload
} from '../../components/settings/help/'

export default {
    name: 'HelpComponent',
    components: {
        FaqSection,
        ContactForm,
        ContactInfoWrapper,
        TutorialsToDownload
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        isShopUser() {
            return this.$store.getters.isShopUser
        }
    }
}
</script>
